export const classMapping = [
  {
    name: 'Trường Kinh tế và Quản lý công',
    faculties: [
      {
        name: 'Khoa Kinh tế học',
        majors: ['Kinh tế học', 'Kinh tế học tài chính'],
      },
      {
        name: 'Khoa Khoa học quản lý',
        majors: [
          'Khoa học quản lý',
          'Quản lý công và chính sách',
          'Quản lý công',
        ],
      },
      {
        name: 'Khoa Kế hoạch & Phát triển',
        majors: ['Kinh tế phát triển'],
      },
      {
        name: 'Khoa Môi trường, Biến đổi khí hậu và Đô thị',
        majors: [
          'Quản lý Tài nguyên và Môi trường',
          'Kinh tế và Quản lý đô thị',
        ],
      },
      {
        name: 'Khoa Đầu tư',
        majors: ['Quản lý dự án', 'Kinh tế đầu tư'],
      },
      {
        name: 'Khoa Luật',
        majors: ['Luật', 'Luật Kinh tế'],
      },
      {
        name: 'Khoa Ngoại ngữ Kinh tế',
        majors: ['Ngôn ngữ Anh'],
      },
    ],
  },
  {
    name: 'Trường Công nghệ',
    faculties: [
      {
        name: 'Khoa Công nghệ thông tin',
        majors: [
          'Công nghệ thông tin',
          'Khoa học máy tính',
          'Kỹ thuật phần mềm',
          'An toàn thông tin',
        ],
      },
      {
        name: 'Khoa Hệ thống thông tin quản lý',
        majors: ['Hệ thống thông tin', 'Hệ thống thông tin quản lý'],
      },
      {
        name: 'Khoa Khoa học dữ liệu & Trí tuệ nhân tạo',
        majors: ['Khoa học dữ liệu', 'Trí tuệ nhân tạo'],
      },
      {
        name: 'Khoa Toán Kinh tế',
        majors: [
          'Định phí Bảo hiểm & Quản trị rủi ro',
          'Khoa học dữ liệu trong Kinh tế và Kinh doanh',
          'Toán Kinh tế',
        ],
      },
      {
        name: 'Khoa Thống kê',
        majors: ['Thống kê Kinh tế'],
      },
    ],
  },
  {
    name: 'Trường Kinh doanh',
    faculties: [
      {
        name: 'Viện Quản trị Kinh doanh',
        majors: ['Kinh doanh số (E-BDB)', 'Quản trị Kinh doanh (E-BBA)'],
      },
      {
        name: 'Khoa Quản trị Kinh doanh',
        majors: [
          'Quản trị Kinh doanh',
          'Quản trị Chất lượng và Đổi mới',
          'Quản trị điều hành thông minh (ESOM)',
        ],
      },
      {
        name: 'Viện Thương mại và Kinh tế Quốc tế',
        majors: [
          'Logistics và Quản lý chuỗi cung ứng',
          'Kinh doanh thương mại',
          'Kinh doanh quốc tế',
          'Thương mại điện tử',
        ],
      },
      {
        name: 'Khoa Marketing',
        majors: ['Marketing', 'Quan hệ công chúng'],
      },
      {
        name: 'Khoa Kinh tế và Quản lý nguồn nhân lực',
        majors: ['Quản trị nhân lực', 'Kinh tế và Quản lý nguồn nhân lực'],
      },
      {
        name: 'Khoa Bảo hiểm',
        majors: ['Bảo hiểm'],
      },
      {
        name: 'Khoa Bất động sản và Kinh tế tài nguyên',
        majors: [
          'Quản lý đất đai',
          'Kinh tế nông nghiệp',
          'Kinh doanh nông nghiệp',
          'Bất động sản',
          'Kinh tế tài nguyên',
        ],
      },
      {
        name: 'Khoa Du lịch & Khách sạn',
        majors: [
          'Quản trị Dịch vụ Du lịch & Lữ hành',
          'Quản trị khách sạn',
          'Quản trị khách sạn quốc tế',
          'Quản trị giải trí và sự kiện',
        ],
      },
      {
        name: 'Viện Kế toán - Kiểm toán',
        majors: ['Kế toán', 'Kiểm toán'],
      },
      {
        name: 'Viện Ngân hàng - Tài chính',
        majors: [
          'Tài chính ngân hàng',
          'Công nghệ tài chính',
          'Đầu tư tài chính',
        ],
      },
    ],
  },
  {
    name: '--',
    faculties: [
      {
        name: 'Viện Đào tạo Tiên tiến, CLC và POHE',
        majors: [
          'Phân tích kinh doanh',
          'POHE – Quản trị khách sạn',
          'POHE – Quản trị lữ hành',
          'POHE – Truyền thông Marketing',
          'POHE – Luật Kinh doanh',
          'POHE – QTKD Thương mại',
          'POHE – Quản lý thị trường',
          'POHE – Thẩm định giá',
          'Chương trình Kiểm toán CLC (Tích hợp chứng chỉ ACCA từ Khóa 65)',
          'Quản trị kinh doanh CLC',
          'Ngân hàng CLC',
          'Kinh tế đầu tư CLC',
          'Quản trị Marketing CLC',
          'Quản trị nhân lực CLC',
          'Kinh tế quốc tế CLC',
          'Tài chính doanh nghiệp CLC',
          'Kinh tế phát triển CLC',
          'Marketing số CLC',
          'Công nghệ thông tin và chuyển đổi số CLC',
          'Quan hệ công chúng CLC',
          'Thương mại điện tử CLC',
          'Logistic và quản lý chuỗi cung ứng CLC',
          'Bảo hiểm CLC tích hợp chứng chỉ ANZIIF',
          'Tài chính Tiên tiến',
          'Kế toán Tiên tiến',
          'Kế hoạch - Tài chính Tiên tiến',
          'Quản trị Kinh doanh Tiên tiến',
          'Kinh doanh quốc tế Tiên tiến',
        ],
      },
    ],
  },
  {
    name: '--',
    faculties: [
      {
        name: 'Viện Đào tạo Quốc tế (IBD)',
        majors: [
          'Khởi nghiệp và Phát triển kinh doanh',
          'Kinh doanh và Marketing',
          'Kinh doanh & Quản trị sự kiện',
          'Quản trị Kinh doanh',
          'Quản trị Kinh doanh Quốc tế',
          'Digital Marketing',
          'Ngân hàng & Tài chính',
        ],
      },
    ],
  },
]

export const majors = classMapping.reduce((acc, school) => {
  school.faculties.forEach((faculty) => {
    faculty.majors.forEach((major) => {
      // Tạo đối tượng với major là khóa
      acc[major] = {
        value: major,
        label: major,
        faculty: faculty.name,
        school: school.name,
      }
    })
  })
  return acc
}, {})
//lay du lieu khoa vien cho book
export const faculties = classMapping.reduce((acc, school) => {
  school.faculties.forEach(faculty => {
    acc.push({value: faculty.name, label:faculty.name})
  })
  return acc
}, [])

export const courseOptions = [
  { value: "67", label: 'K67' },
  { value: "66", label: 'K66' },
  { value: "65", label: 'K65' },
  { value: "64", label: 'K64' },
  { value: "63", label: 'K63' },
  { value: "62", label: 'K62' },
  { value: "61", label: 'K61' },
]
export const getMaxCourseValue = (options) => {
  const maxValue = Math.max(...options.map((option) => option.value))
  return String(maxValue)
}
export const textFieldCreateData = [
  {
    label: 'Mã tài khoản',
    type: 'text',
    name: 'id',
    length: 8,
    required: true,
    disabled: false,
  },
  { label: 'Tên tài khoản', type: 'text', name: 'name', required: true },
  {
    label: 'Khoá',
    type: 'select',
    name: 'course',
    search: false,
    required: true,
    options: courseOptions,
  },
  {
    label: 'Nhóm',
    type: 'checkbox',
    name: 'groups',
    required: true,
    options: [
      { value: 'STUDENT', label: 'Sinh viên' },
      { value: 'DATA_TRACKING', label: 'Phân tích dữ liệu' },
    ],
  },
  {
    label: 'Email cá nhân',
    type: 'email',
    name: 'personalEmail',
    required: false,
  },
  {
    label: 'Email trường',
    type: 'text',
    name: 'schoolEmail',
    required: true,
  },
  {
    label: 'Số điện thoại',
    type: 'text',
    name: 'phoneNumber',
    length: 10,
    required: false,
  },
  {
    label: 'Lớp',
    type: 'select',
    name: 'className',
    required: true,
    search: true,
    placeholder: 'Vui lòng chọn lớp',

    options: Object.values(majors).map((major) => {
      return { value: major.value, label: major.label }
    }),
  },
  {
    label: 'Khoa/Viện',
    type: 'text',
    name: 'faculty',
    required: true,
    disabled: true,
  },
  {
    label: 'Trường',
    type: 'text',
    name: 'school',
    required: true,
    disabled: true,
  },
]
